module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 122.5befbb6b.png";